import React from "react";
import { useClasses } from "../../../";
import classNames from "classnames";
const styles = (theme) => {
    return {
        label: {
            position: "absolute",
            fontSize: "0.8rem",
            color: "#797979",
            marginTop: "0px",
            zIndex: 0,
            transition: "margin-top 150ms linear, margin-left 150ms linear, font-size 150ms linear, color 150ms linear",
        },
        inlineLabel: {
            position: "absolute",
            fontSize: "1rem",
            marginTop: "5px",
            marginLeft: "8px",
            color: "#797979",
            cursor: "text",
            opacit: 1,
            pointerEvents: "none",
            "@media print": {
                position: "absolute",
                fontSize: "0.8rem",
                color: "#797979",
                marginTop: "0px",
                zIndex: 0,
                transition: "margin-top 150ms linear, margin-left 150ms linear, font-size 150ms linear, color 150ms linear",
            },
        },
        closedLabel: {
            position: "absolute",
            fontSize: "1rem",
            marginTop: "23px",
            marginLeft: "8px",
            color: "#797979",
            cursor: "text",
            "@media print": {
                position: "absolute",
                fontSize: "0.8rem",
                color: "#797979",
                marginTop: "0px",
                zIndex: 0,
                transition: "margin-top 150ms linear, margin-left 150ms linear, font-size 150ms linear, color 150ms linear",
            },
        },
        inlineLabelOpen: {
            opacity: 0,
            "@media print": {
                opacity: 1,
            },
        },
        hasError: {
            color: "rgba(156, 0, 0, 1)",
        },
        doNotDisplay: {
            "@media print": {
                display: "inline",
            },
        },
    };
};
const Label = (props) => {
    const { open, inline, label, readOnly, isFocused, hasValue, hasError, onClick, } = props;
    const classes = useClasses(styles);
    return (React.createElement("label", { htmlFor: label, className: classNames([
            inline ? classes.inlineLabel : classes.label,
            !readOnly &&
                !inline &&
                !open &&
                !isFocused &&
                !hasValue &&
                classes.closedLabel,
            inline && hasValue && classes.inlineLabelOpen,
            hasError && classes.hasError,
            !hasValue || !inline ? classes.doNotDisplay : "",
        ]), onClick: (e) => {
            if (onClick)
                onClick(e);
        } }, label));
};
export default Label;
